<template>
  <div
      :class="['top', {
            'top--animated-height': animationActivated.height
        }]"
  >
    <a
        data-scroll
        href="#top"
        class="top__left-side"
    >
      <img
        v-if="animationCompleted"
        src="../assets/svg/well-done.svg"
        draggable="false"
        alt="logo wd"
        class="top__logo"
      >
    </a>
    <div class="top__right-side">
      <nav
          v-if="animationCompleted"
          class="top__full-menu"
      >
        <a data-scroll href="#services">Услуги и цены</a>
        <a data-scroll href="#about">О нас</a>
        <a data-scroll href="#order">Контакты</a>
      </nav>
      <!--<div class="top__menu-toggle">-->
      <!--✕-->
      <!--</div>-->
      <!--<nav-->
      <!--class="top__menu-mobile"-->
      <!--&gt;-->
      <!---->
      <!--</nav>-->
    </div>
  </div>
</template>

<script>
import { wait } from '../utils/functions';

export default {
  name: 'top',
  data() {
    return {
      animationCompleted: false,
      animationActivated: {
        height: false
      }
    }
  },
  methods: {
    async initAnimation() {
      await this.playAnimation();
      this.animationCompleted = true;
      this.$emit('animation-ends');
    },
    async playAnimation() {
      await wait(100);
      this.animationActivated.height = true;
      await wait(100);
    }
  },
  mounted() {
    this.initAnimation();
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/vars';

.top {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  background: white;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 80px;
  border-bottom: 1px solid $color-border;
  transition: height 250ms cubic-bezier(.1, 1.56, .77, -0.44) 100ms;

  &--animated-height {
    height: 80px;
  }

  &__studio-name {
    color: $color-primary;
    font-weight: 900;
  }

  &__studio-name-prefix {
    background-color: $color-primary;
    color: white;
  }

  &__studio-description {
    font-size: 14px;
    line-height: 14px;
    font-weight: 400;
    text-transform: uppercase;
    color: $color-text;
  }

  &__left-side {
    display: flex;
    align-items: center;
    user-select: none;
  }

  &__logo {
    height: 54px;
    object-fit: contain;
  }

  &__full-menu {
    display: flex;
    margin-left: 60px;

    a {
      margin-right: 28px;
      font-size: 14px;
      line-height: 14px;
      color: $color-text;
      font-weight: 400;
      text-transform: uppercase;
      cursor: pointer;
    }

    a:hover {
      color: $color-primary;
    }

    a:last-child {
      margin-right: 0;
    }
  }

  &__menu-toggle {
    font-size: 32px;
  }
}

/* Large desktops and laptops */
@media (min-width: 1200px) {

}

/* Landscape tablets and medium desktops */
@media (min-width: 992px) and (max-width: 1199px) {

}

/* Portrait tablets and small desktops */
@media (min-width: 768px) and (max-width: 991px) {

}

/* Over mobile devices */
@media (min-width: 768px) {
  .top {
    &__menu-toggle {
      display: none;
    }
  }
}

/* Landscape phones and portrait tablets */
@media (max-width: 767px) {
  .top {
    padding: 0 20px;

    &__full-menu {
      display: none;
    }

    &__studio-description {
      font-size: 12px;
    }
  }
}

/* Portrait phones and smaller */
@media (max-width: 480px) {

}

/* Iphone 5 */
@media (max-width: 320px) {

}
</style>
